import { FileFragment } from "graphql/types";

const SUPPORTED_FILE_TYPES = ["application/pdf"];

export const isSupportedFileType = (file: File | FileFragment): boolean => {
  const fileType = "type" in file ? file.type : file.contentType;
  return SUPPORTED_FILE_TYPES.includes(fileType);
};
